<script setup lang="ts">
import type { AggregationTermEntry } from '~/models/Content/Response'
import { KsButton } from '@aschehoug/kloss'

const props = defineProps<{
  entry?: AggregationTermEntry
  name: string
}>()
</script>
<template>
  <KsButton
    size="medium"
    variant="tertiary"
  >
    <slot />
    <div class="flex w-full justify-between">
      <span
        class="first-letter:capitalize"
        v-text="props.name"
      />
      <span
        v-if="props.entry"
        class="font-normal text-gray-40"
        v-text="props.entry.count"
      />
    </div>
  </KsButton>
</template>
